import React from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {connect} from 'react-redux';
import {Button, Tooltip} from '@perion-undertone/ut-react-common';
import {importFile, importFileFailed, removeUploadErrorMessage, textProvider, PerionLoader} from './imports';

const CONSTANT_TEXTS = {
    IMPORT_BTN: textProvider.getText('adSlots', 'import'),
    IMPORT_MSG: textProvider.getText('adSlots', 'importMsg')
}
const CLASS_NAMES = {
    IMPORT_FILE_CONTAINER: 'placement-ad-slots-import-container',
    AD_SLOTS_IMPORT: 'placement-ad-slots-import',
    UPLOAD_ZONE: 'upload-zone',
    DRAG_FILE: 'import-file-wrapper',
    IMPORT_FILE_ERROR: 'import-file-error'
};

const ALLOWED_FILE_FORMATS = ['.txt', '.csv', '.xls', '.xlsx'];

const ImportFile = (props) => {
    const {isImporting, err} = props;

    const onDropAccepted = (files) => {
        props.importFile(files[0]);
    };

    const onDropRejected = () => {
        props.importFileFailed('File is not supported');
        setTimeout(() => {
            props.removeUploadErrorMessage();
        }, 3000);
    };

    return (
        <div className={CLASS_NAMES.IMPORT_FILE_CONTAINER}>
            {err && 
                <div className={CLASS_NAMES.IMPORT_FILE_ERROR}>
                    {err}
                </div>
            }
            <Dropzone 
                multiple={false}
                accept={ALLOWED_FILE_FORMATS}
                onDropRejected={onDropRejected}
                onDropAccepted={onDropAccepted}
            >
                {({getRootProps, getInputProps}) => (
                    <div className={CLASS_NAMES.AD_SLOTS_IMPORT}>
                        {isImporting ? (
                            <PerionLoader size="small" overlay={false} />
                        ) : (
                            <section className={cx(CLASS_NAMES.UPLOAD_ZONE)}>
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className={CLASS_NAMES.DRAG_FILE}>
                                        <Tooltip
                                            appendToBody
                                            placement='top'
                                            hookId="ad-slots-import-tooltip-message"
                                            trigger={
                                                <div>
                                                    <Button 
                                                        className="adslots-action-btn"
                                                        hookId="ad-slots-action-btn"
                                                    >
                                                        {CONSTANT_TEXTS.IMPORT_BTN}
                                                    </Button>
                                                </div>
                                            }
                                        >
                                            {CONSTANT_TEXTS.IMPORT_MSG}
                                        </Tooltip>
                                    </div>
                                </div>
                            </section>
                        )}
                    </div>
                )}
            </Dropzone>
        </div>
    );
};

ImportFile.propTypes = {
    importFile: PropTypes.func.isRequired,
    importFileFailed: PropTypes.func.isRequired,
    removeUploadErrorMessage: PropTypes.func.isRequired,
    isImporting: PropTypes.bool,
    err: PropTypes.string
};

const mapStateToProps = ({placements}) => ({
    isImporting: placements.currentGroup?.isImporting || false,
    err: placements.currentGroup?.err
});

const mapDispatchToProps = {
    importFile,
    importFileFailed,
    removeUploadErrorMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportFile);
